import { CommonModule } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import { ControlContainer, ReactiveFormsModule } from '@angular/forms';
import { type IPropertyDefinition } from '@suvo/shared/property';
import { RichTextControlComponent } from './rich-text-control.component';

@Component({
  selector: 'property-widget',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, RichTextControlComponent],
  viewProviders: [
    {
      provide: ControlContainer,
      useFactory: () => inject(ControlContainer, { skipSelf: true }),
    },
  ],
  styles: `
    .property-field {
      margin-bottom: 12px;
      display: block;
      width: 100%;
    }

    .property-field > label {
      display: block;
      margin-bottom: 6px;
      font-weight: 500;
    }

    .property-field input,
    .property-field textarea,
    .property-field select {
      width: 100%;
      box-sizing: border-box;
      min-height: 36px;
    }

    .property-field textarea {
      min-height: 72px;
      resize: vertical;
    }
  `,
  template: `
    <div class="property-field">
      <label [attr.for]="property.name">{{ property.displayName || property.name }}</label>

      @switch (property.type) {
        @case ('INT') {
          <input [id]="property.name" type="number" [formControlName]="property.name" />
        }
        @case ('BOOLEAN') {
          <input [id]="property.name" type="checkbox" [formControlName]="property.name" />
        }
        @case ('RICHTEXT') {
          <suvo-property-rich-text-control [formControlName]="property.name"></suvo-property-rich-text-control>
        }
        @default {
          <input [id]="property.name" [attr.type]="inputType" [formControlName]="property.name" />
        }
      }
    </div>
  `,
})
export class PropertyWidgetComponent {
  @Input()
  property!: IPropertyDefinition;

  get inputType(): string {
    if (this.property.type === 'DATE') {
      return 'date';
    }

    return 'text';
  }
}
